// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1677":"e219cfc7","6396":"e219cfc7"}[chunkId] + ".chunk.css";
};